@if (valuesWidget) {
    <mvs-widget
            [widgetData]="valuesWidget"
            (onObjectSelect)="onItemSelect($event)"
    ></mvs-widget>
}
